// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Fetch = require("rescript-webapi/src/Webapi/Webapi__Fetch.res.js");
var Utils$ReactHooksTemplate = require("./utils.res.js");

function fetchPostJSON(url, item) {
  return Js_promise.then_((function (prim) {
                return prim.json();
              }), fetch(url, Webapi__Fetch.RequestInit.make("Post", [
                      [
                        "Content-Type",
                        "application/json"
                      ],
                      [
                        "X-CSRF-TOKEN",
                        Utils$ReactHooksTemplate.csrfToken
                      ]
                    ], Caml_option.some(JSON.stringify(item)), undefined, undefined, undefined, "SameOrigin", undefined, undefined, undefined, undefined, undefined, undefined)));
}

function fetchPatchJSON(url, item) {
  return Js_promise.then_((function (prim) {
                return prim.json();
              }), fetch(url, Webapi__Fetch.RequestInit.make("Patch", [
                      [
                        "Content-Type",
                        "application/json"
                      ],
                      [
                        "Accept",
                        "application/json"
                      ],
                      [
                        "X-CSRF-TOKEN",
                        Utils$ReactHooksTemplate.csrfToken
                      ]
                    ], Caml_option.some(JSON.stringify(item)), undefined, undefined, undefined, "SameOrigin", undefined, undefined, undefined, undefined, undefined, undefined)));
}

function fetchPostEncodedJSON(url, item) {
  return Js_promise.then_((function (prim) {
                return prim.json();
              }), fetch(url, Webapi__Fetch.RequestInit.make("Post", [
                      [
                        "Content-Type",
                        "application/json"
                      ],
                      [
                        "Accept",
                        "application/json"
                      ],
                      [
                        "X-CSRF-TOKEN",
                        Utils$ReactHooksTemplate.csrfToken
                      ]
                    ], Caml_option.some(JSON.stringify(item)), undefined, undefined, undefined, "SameOrigin", undefined, undefined, undefined, undefined, undefined, undefined)));
}

function fetchGetJSON(url) {
  return Js_promise.then_((function (prim) {
                return prim.json();
              }), fetch(url, Webapi__Fetch.RequestInit.make("Get", undefined, undefined, undefined, undefined, undefined, "SameOrigin", undefined, undefined, undefined, undefined, undefined, undefined)));
}

function fetchGetJSONWithHeader(url) {
  return Js_promise.then_((function (param) {
                return Promise.resolve([
                            param[1],
                            param[0]
                          ]);
              }), Js_promise.then_((function (response) {
                    return Promise.resolve([
                                response.json(),
                                response.headers
                              ]);
                  }), fetch(url, Webapi__Fetch.RequestInit.make("Get", undefined, undefined, undefined, undefined, undefined, "SameOrigin", undefined, undefined, undefined, undefined, undefined, undefined))));
}

function fetchGetJSONDecode(url, decoder) {
  return Js_promise.then_((function (json) {
                return Promise.resolve(Curry._1(decoder, json));
              }), fetchGetJSON(url));
}

exports.fetchPostJSON = fetchPostJSON;
exports.fetchPatchJSON = fetchPatchJSON;
exports.fetchPostEncodedJSON = fetchPostEncodedJSON;
exports.fetchGetJSON = fetchGetJSON;
exports.fetchGetJSONWithHeader = fetchGetJSONWithHeader;
exports.fetchGetJSONDecode = fetchGetJSONDecode;
/* Utils-ReactHooksTemplate Not a pure module */
